import Api from '../Api/api'
import { push } from 'connected-react-router'
// import jwt_decode from 'jwt-decode'
import { clear } from "react-redux-permissions"
import xmlrpc from 'xmlrpc'
import RecipientsTestData from '../TestData/Recipients'
import VisitsTestData from '../TestData/Visits'
import store from './store'
import uuid from 'react-uuid'

export const LOGIN_ACTION = 'LOGIN_ACTION'
export const LOGIN_ERROR_ACTION = 'LOGIN_ERROR_ACTION'
export const LOGGED_IN_ACTION = 'LOGGED_IN_ACTION'
export const UPDATE_AUTH_TOKEN = 'UPDATE_AUTH_TOKEN'
export const CLEAR_AUTH = 'CLEAR_AUTH'
export const SET_TEAM = 'SET_TEAM'
export const UPDATE_DATA = 'UPDATE_DATA'
export const UPDATE_GLOBAL_STATE = 'UPDATE_GLOBAL_STATE'
export const ADD_SESSION_TO_CURRENT_VISIT = 'ADD_SESSION_TO_CURRENT_VISIT'
export const ADD_VISIT = 'ADD_VISIT'
export const DELETE_STATUS = 'DELETE_STATUS'



export const addVisitAction = (data = {}) => {
    return (dispatch, getState) => {
        throw 'DEPRECATED';
        const sync_queue = JSON.parse(localStorage.getItem('sync_queue'))
        const transformed_data = {
            ...data,
        }
        if (!data.id) {
            transformed_data.visit_id = uuid()
            transformed_data.note_session_details_ids = data.note_session_details_ids
            const new_queue = sync_queue.queue.concat([{
                id: uuid(),
                action: 'add_visit',
                data: transformed_data
            }])
            localStorage.setItem('sync_queue', JSON.stringify({
                lastUpdate: Date.now(),
                queue: new_queue
            }))

            const new_visits = {
                ...getState().app.global.visits,
                [data.visit_id]: [{
                    ...data,
                }]
            }

            dispatch(updateGlobalState({
                visits: new_visits
            }))
        }
    }
}

export const updateVisitAction = (data = {}) => {
    return (dispatch, getState) => {
        throw 'DEPRECATED';
        const sync_queue = JSON.parse(localStorage.getItem('sync_queue'))
        const transformed_data = {
            ...data,
            // date: data.date_start + ' ' + data.time_start
        }
        if (data.id) {
            // transformed_data.visit_id = uuid()
            transformed_data.note_session_details_ids = data.note_session_details_ids
            const new_queue = sync_queue.queue.concat([{
                id: uuid(),
                action: 'update_visit',
                data: transformed_data
            }])
            localStorage.setItem('sync_queue', JSON.stringify({
                lastUpdate: Date.now(),
                queue: new_queue
            }))

            const address = getState().app.global.recipients[data.recipient_id][0].address
            let service_address1 = ''
            let end_address_1 = ''
            if (address) {
                address.forEach(element => {
                    if (element.id === data.start_address_id) {
                        service_address1 = element.street1
                    }
                    if (element.id === data.end_address_id) {
                        end_address_1 = element.street1
                    }
                });
            }

            const new_visits = {
                ...getState().app.global.visits,
                [data.bam_id]: [{
                    ...data,
                    service_address1,
                    end_address_1
                }]
            }

            dispatch(updateGlobalState({
                visits: new_visits
            }))
        }
    }
}

export const upsertVisitAction = (data = {}) => {
    return (dispatch, getState) => {
        const sync_queue = JSON.parse(localStorage.getItem('sync_queue'))
        const transformed_data = {
            ...data,
            // date: data.date_start + ' ' + data.time_start
        }

        // if(!data.bam_id){
        //     data.bam_id = uuid()
        // }

        // transformed_data.visit_id = uuid()
        transformed_data.note_session_details_ids = data.note_session_details_ids
        const new_queue = sync_queue.queue.concat([{
            id: uuid(),
            action: 'upsert_visit',
            data: transformed_data
        }])
        localStorage.setItem('sync_queue', JSON.stringify({
            lastUpdate: Date.now(),
            queue: new_queue
        }))

        const address = getState().app.global.recipients[data.recipient_id][0].address
        let service_address1 = ''
        let end_address_1 = ''
        if (address) {
            address.forEach(element => {
                if (element.id === data.start_address_id) {
                    service_address1 = element.street1
                }
                if (element.id === data.end_address_id) {
                    end_address_1 = element.street1
                }
            });
        }

        const new_visits = {
            ...getState().app.global.visits,
            [data.bam_id]: [{
                ...data,
                service_address1,
                end_address_1
            }]
        }

        dispatch(updateGlobalState({
            visits: new_visits
        }))
    }
}

export const addSessionToCurrentVisitAction = (payload = {}) => {
    return {
        type: ADD_SESSION_TO_CURRENT_VISIT,
        payload
    }
}

export const loggedInAction = (payload = {}) => {
    return {
        type: LOGGED_IN_ACTION,
        payload
    }
}
export const loginErrorAction = (payload = {}) => {
    return {
        type: LOGIN_ERROR_ACTION,
        payload
    }
}
export const updateAuthToken = (payload = {}) => {
    return {
        type: UPDATE_AUTH_TOKEN,
        payload
    }
}
export const clearAuth = (payload = {}) => {
    return {
        type: CLEAR_AUTH,
        payload
    }
}
export const setTeam = (payload = {}) => {
    return {
        type: SET_TEAM,
        payload
    }
}

export const updateData = (payload = {}) => {
    return {
        type: UPDATE_DATA,
        payload
    }
}

export const updateGlobalState = (payload = {}) => {
    return {
        type: UPDATE_GLOBAL_STATE,
        payload
    }
}

export const deleteStatus = (payload = {}) => {
    return {
        type: DELETE_STATUS,
        payload
    }
}

export const loginAction = (payload = {}) => {
    return (dispatch, getState) => {
        let url = payload['url']
        const email = payload['email']
        const password = payload['password']
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            url = 'https://' + url
        }

        // Get db
        const re = new RegExp('^https?://([^.]+).*$')
        const parts = re.exec(url)
        var db = parts[1]
        if (db === 'localhost') {
            db = 'test10'
        }
        const client = xmlrpc.createClient({
            url: url + '/xmlrpc/2/common'
        })

        client.methodCall('version', [], (error, value) => {
            // Results of the method response
        })

        return new Promise((resolve, reject) => {
            client.methodCall('authenticate', [db, email, password, {}], (error, value) => {
                // Results of the method response
                if (typeof value === "undefined") {
                    dispatch(loginErrorAction(error))
                    reject()
                }
                else {
                    payload['uid'] = value
                    // sessionStorage.setItem('auth', JSON.stringify(payload))
                    localStorage.setItem('auth', JSON.stringify(payload))
                    dispatch(clear())
                    dispatch(loggedInAction({
                        user: payload
                    }))
                    // dispatch(updatePermissionsAction(user))
                    // dispatch(push('/dashboard'))
                    dispatch(push('/configure-pin'))
                    resolve()
                }
            })
        })


        // return Api.post(payload['url'] + '/xmlrpc/2/common', payload)
        //     .then(json => {
        //         if(json.success){
        //             delete json.success
        //             const user = jwt_decode(json.authToken)
        //             const payload = {
        //                 ...json,
        //                 user
        //             }
        //             sessionStorage.setItem('auth', JSON.stringify(payload))
        //             dispatch(clear())
        //             dispatch(loggedInAction(payload))
        //             dispatch(updatePermissionsAction(user))
        //             dispatch(push('/dashboard'))
        //         }
        //         else{
        //             dispatch(loginErrorAction(json))
        //         }
        //     })
    }
}

export const logoutAction = (payload = {}) => {
    return function (dispatch, getState) {
        return new Promise((res, rej) => {
            // sessionStorage.removeItem('auth')
            localStorage.removeItem('auth')
            dispatch(clear())
            dispatch(clearAuth())
            dispatch(push('/login'))
            res()
        })
    }
}

export const updatePermissionsAction = user => {
    return (dispatch, getState) => {
        // for (let i = 0; i < user.roles.length; i++) {
        //     const role = user.roles[i];
        //     for (let j = 0; j < role.permissions.length; j++) {
        //         const permission = role.permissions[j];
        //         dispatch(add(permission))
        //     }
        // }
    }
}

// export const loadAuthFromStore = () => {
//     return (dispatch, getState) => {
//         return new Promise((res, rej) => {
//             try{
//                 // const auth = sessionStorage.getItem('auth')
//                 const auth = localStorage.getItem('auth')

//                 if(auth){
//                     const auth_obj = JSON.parse(auth)
//                     dispatch(loggedInAction(auth_obj))
//                     dispatch(updatePermissionsAction(auth_obj.user))
//                     const pin_configuration = sessionStorage.getItem('pin-configuration')
//                     if(!pin_configuration){
//                         dispatch(push('/configure-pin'))
//                     }
//                 }
//                 else{
//                     // dispatch(push('/dashboard'))
//                     dispatch(logoutAction())
//                 }
//                 res()
//             }
//             catch(e){
//                 rej(e)
//             }
//         })
//     }
// }

export const loadData = (silent = true) => {
    return (dispatch, getState) => {
        return new Promise((res, rej) => {
            try {
                const visit_status_element_id = uuid()
                const recipient_status_element_id = uuid()

                dispatch(updateGlobalState({
                    status_list: getState().app.global.status_list.concat([{
                        id: visit_status_element_id,
                        type: 'indefinite',
                        text: 'Loading visits'
                    },
                    {
                        id: recipient_status_element_id,
                        type: 'indefinite',
                        text: 'Loading recipients'
                    }
                    ])
                }))

                // const auth = sessionStorage.getItem('auth')
                if (window.location.href.indexOf('localhost:') !== -1) {

                    const recipientsTestResponse = RecipientsTestData

                    const notesTestResponse = VisitsTestData



                    localStorage.setItem('recipients-offline-data', JSON.stringify(recipientsTestResponse))
                    dispatch(updateData({
                        recipients: recipientsTestResponse
                    }))

                    localStorage.setItem('notes-offline-data', JSON.stringify(notesTestResponse))
                    dispatch(updateData({
                        visits: notesTestResponse
                    }))

                    setTimeout(() => {
                        dispatch(deleteStatus({
                            id: visit_status_element_id
                        }))
                    }, 5000)

                    setTimeout(() => {
                        dispatch(deleteStatus({
                            id: recipient_status_element_id
                        }))
                    }, 10000)
                }
                else {
                    fetch('/api_evv/get_visits')
                        .then(response => response.json())
                        .then(response => {
                            localStorage.setItem('notes-offline-data', JSON.stringify(response))
                            const state = store.getState()
                            let currentVisit = {}
                            if (typeof state.app.global.currentVisit !== 'undefined' && JSON.stringify(state.app.global.currentVisit) !== JSON.stringify({})) {
                                currentVisit = response[state.app.global.currentVisit.id][0]
                            }

                            // const status_index = old_status_list.find(x => x.id === status_element_id)

                            dispatch(deleteStatus({
                                id: visit_status_element_id
                            }))
                            // const new_status_list = [].concat(getState().app.global.status_list).filter(x => x.id !== visit_status_element_id)

                            dispatch(updateData({
                                visits: response,
                                currentVisit,
                                // status_list: new_status_list
                            }))
                        })
                        .catch(err => {
                            const new_status_list = [].concat(getState().app.global.status_list).filter(x => x.id !== visit_status_element_id)

                            if (!silent) {
                                new_status_list.push({
                                    id: uuid(),
                                    type: 'persistent',
                                    text: 'Error loading visits'
                                })
                            }

                            dispatch(updateData({
                                visits: JSON.parse(localStorage.getItem('notes-offline-data') || '[]'),
                                status_list: new_status_list,
                            }))
                        })

                    fetch('/api_evv/get_recipients')
                        .then(response => response.json())
                        .then(response => {
                            localStorage.setItem('recipients-offline-data', JSON.stringify(response))

                            dispatch(deleteStatus({
                                id: recipient_status_element_id
                            }))
                            // const new_status_list = [].concat(getState().app.global.status_list).filter(x => x.id !== recipient_status_element_id)
                            dispatch(updateData({
                                recipients: response,
                                // status_list: new_status_list
                            }))
                        })
                        .catch(err => {
                            const new_status_list = [].concat(getState().app.global.status_list).filter(x => x.id !== recipient_status_element_id)

                            if (!silent) {
                                new_status_list.push({
                                    id: uuid(),
                                    type: 'persistent',
                                    text: 'Error loading recipients'
                                })
                            }

                            dispatch(updateData({
                                recipients: JSON.parse(localStorage.getItem('recipients-offline-data') || '[]'),
                                status_list: new_status_list

                            }))
                        })
                }

                res()
            }
            catch (e) {
                rej(e)
            }
        })
    }
}

export const requestUsersAction = (payload = {}) => {
    return function (dispatch, getState) {
        return Api.get(Api.getApiBaseUrl() + 'api/user', payload)
            .then(json => {
                console.info(json)
            })
    }
}